export type PagePreview = {
  id: string;
  label: string;
  title: string;
  src: string;
};

export const pagePreviews: PagePreview[] = [
  {
    id: 'safe-home-map',
    label: 'Home Safety',
    title: 'The Safe Home Map — room-by-room risk assessment',
    src: 'https://cdn.magicpatterns.com/uploads/2m3nmQte8SggSaHSJHnmZQ/Screenshot_20260908_200549_Drive.jpg',
  },
  {
    id: 'sit-to-stand',
    label: 'Mobility',
    title: 'Movement 1 — Sit to Stand, lower body strength',
    src: 'https://cdn.magicpatterns.com/uploads/nCK8PGKux47aQribwN2GUA/Screenshot_20260908_200429_Drive.jpg',
  },
  {
    id: 'seated-standing-march',
    label: 'Mobility',
    title: 'Movement 4 — Seated & Standing March, cardio activation',
    src: 'https://cdn.magicpatterns.com/uploads/jRZUSuzbyNZFARU7hkvMQB/Screenshot_20260908_200452_Drive.jpg',
  },
  {
    id: 'daily-medication-schedule',
    label: 'Daily Tracking',
    title: 'Daily Medication Schedule — visual dosing timeline',
    src: 'https://cdn.magicpatterns.com/uploads/5yW2f61Bar3fBHpyTbc1q9/Screenshot_20260908_201104_Drive.jpg',
  },
  {
    id: 'medication-administration-record',
    label: 'Vital Log',
    title: 'Medication Administration Record — why it saves lives',
    src: 'https://cdn.magicpatterns.com/uploads/k7BiAWViC3Hv48WFGZ2RFH/Screenshot_20260908_200920_Drive.jpg',
  },
  {
    id: 'senior-first-aid-choking',
    label: 'Emergency',
    title: 'Senior First Aid — modified Heimlich for choking',
    src: 'https://cdn.magicpatterns.com/uploads/dWnzYZsdnwoTKVWPNkZ8qN/Screenshot_20260908_201032_Drive.jpg',
  },
];
